import React from "react"
import { Text, Box, Link, Flex, Heading } from "rebass"
import styled, { withComponent } from "styled-components"
import { Carousel } from "react-responsive-carousel"

import { faQuoteLeft } from "@fortawesome/fontawesome-free-solid"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"

import colors from "../../config/colors.js"

import styles from "react-responsive-carousel/lib/styles/carousel.min.css"

import SliderPanel from "../SliderPanel"

const Icon = styled(FontAwesomeIcon)`
  align-self: center;
`

import SectionHeader from "../SectionHeader"

const FeatureSlider = ({ quotes, bg, iconColor, color, headingColor }) => (
  <Flex flexDirection="column" flex="1" py={5} bg={bg}>
    <Flex justifyContent="center" pb={4}>
      <Icon icon={faQuoteLeft} size="2x" color={colors.yellow} />
    </Flex>
    <SectionHeader title="What our customers say" color={headingColor} />
    <div style={{ maxWidth: "90vw" }}>
      <Carousel
        interval={7500}
        showArrows={false}
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        dynamicHeight={true}
        autoPlay={true}
      >
        {quotes.map((testimonial, i) => (
          <SliderPanel
            key={i}
            color={color}
            bg={bg}
            testimonial={testimonial}
          />
        ))}
      </Carousel>
    </div>
  </Flex>
)

export default FeatureSlider



// WEBPACK FOOTER //
// ./src/components/FeatureSlider/index.js